// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SubscribedPhotoblogs":"tj_a bhu_b bhu_bj","SubscribedPhotoblogs__link":"tj_b bhu_a bhu_r"};